// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Estimates_textareaContainer {
        display: flex;
        flex-grow: 1;

        padding: 20px;

        border-radius: 8px;

        overflow: hidden;
}

.Estimates_input {
        display: flex;
        flex-grow: 1;

        border: 1px solid #e4e4e4;
        border-radius: 8px;

        padding: 10px 6.5px;

        resize: none;

        font-size: 14px;

        overflow-y: auto;
}

.Estimates_input.file {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 12.5px;
}

.Estimates_file {
        border: 1px solid #e4e4e4;
        padding: 10px;

        font-family: "Montserrat";
        font-size: 12px;
        font-weight: 500;

        min-height: -moz-fit-content;

        min-height: fit-content;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
}

.Estimates_techstackInputs {
        padding: 20px;
        padding-top: 0;

        display: flex;
        gap: 15px;
}

.Estimates_dropdownContainer {
        height: 35px;
        max-width: 50%;

        display: flex;
        flex-grow: 1;

        border: 1px solid #e4e4e4;
        border-radius: 8px;
}

.Estimates_dropdown {
        width: 100%;

        border: none;
        outline: none;

        padding: 0 10px;
        border-right: 10px solid transparent;

        border-radius: 8px;

        font-family: "Montserrat";
        font-size: 12px;
        font-weight: 500;

        cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/screens/Estimates/Estimates.css"],"names":[],"mappings":"AAAA;QACQ,aAAa;QACb,YAAY;;QAEZ,aAAa;;QAEb,kBAAkB;;QAElB,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,YAAY;;QAEZ,yBAAyB;QACzB,kBAAkB;;QAElB,mBAAmB;;QAEnB,YAAY;;QAEZ,eAAe;;QAEf,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,eAAe;AACvB;;AAEA;QACQ,yBAAyB;QACzB,aAAa;;QAEb,yBAAyB;QACzB,eAAe;QACf,gBAAgB;;QAEhB,4BAAuB;;QAAvB,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB;AAC/B;;AAEA;QACQ,aAAa;QACb,cAAc;;QAEd,aAAa;QACb,SAAS;AACjB;;AAEA;QACQ,YAAY;QACZ,cAAc;;QAEd,aAAa;QACb,YAAY;;QAEZ,yBAAyB;QACzB,kBAAkB;AAC1B;;AAEA;QACQ,WAAW;;QAEX,YAAY;QACZ,aAAa;;QAEb,eAAe;QACf,oCAAoC;;QAEpC,kBAAkB;;QAElB,yBAAyB;QACzB,eAAe;QACf,gBAAgB;;QAEhB,eAAe;AACvB","sourcesContent":[".Estimates_textareaContainer {\n        display: flex;\n        flex-grow: 1;\n\n        padding: 20px;\n\n        border-radius: 8px;\n\n        overflow: hidden;\n}\n\n.Estimates_input {\n        display: flex;\n        flex-grow: 1;\n\n        border: 1px solid #e4e4e4;\n        border-radius: 8px;\n\n        padding: 10px 6.5px;\n\n        resize: none;\n\n        font-size: 14px;\n\n        overflow-y: auto;\n}\n\n.Estimates_input.file {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        padding: 12.5px;\n}\n\n.Estimates_file {\n        border: 1px solid #e4e4e4;\n        padding: 10px;\n\n        font-family: \"Montserrat\";\n        font-size: 12px;\n        font-weight: 500;\n\n        min-height: fit-content;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n}\n\n.Estimates_techstackInputs {\n        padding: 20px;\n        padding-top: 0;\n\n        display: flex;\n        gap: 15px;\n}\n\n.Estimates_dropdownContainer {\n        height: 35px;\n        max-width: 50%;\n\n        display: flex;\n        flex-grow: 1;\n\n        border: 1px solid #e4e4e4;\n        border-radius: 8px;\n}\n\n.Estimates_dropdown {\n        width: 100%;\n\n        border: none;\n        outline: none;\n\n        padding: 0 10px;\n        border-right: 10px solid transparent;\n\n        border-radius: 8px;\n\n        font-family: \"Montserrat\";\n        font-size: 12px;\n        font-weight: 500;\n\n        cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
